module.exports = __webpack_public_path__ + "img/mao.7d35b7a4.svg";